import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import hero1 from "../assets/hero1.avif";

const headline = "Integrated Solutions for a Safer, Smarter Future";
const paragraph =
  "We specialize in construction & civil works, ICT & IoT systems, electrical installations, and fire protection solutions—delivering end-to-end services that build, connect, and protect modern infrastructures.";

function useTypingEffect(text, speed = 50) {
  const [displayed, setDisplayed] = useState("");
  useEffect(() => {
    setDisplayed("");
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed(text.slice(0, i + 1));
      i++;
      if (i === text.length) clearInterval(interval);
    }, speed);
    return () => clearInterval(interval);
  }, [text, speed]);
  return displayed;
}

function Hero() {
  const typedHeadline = useTypingEffect(headline, 40);

  return (
    <section
      className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: `url(${hero1})`,
        fontFamily: "'Inter', 'Poppins', 'Nunito Sans', sans-serif'",
      }}
    >
      {/* Dark transparent overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />

      {/* Content */}
      <div
        className="relative z-10 w-full max-w-6xl mx-auto 
                   flex flex-col items-center text-center 
                   px-4 sm:px-6 md:px-10 py-16 sm:py-20 md:py-28"
      >
        <motion.h1
          className="text-white text-[40px] sm:text-[48px] md:text-[60px] lg:text-[72px] 
                     font-extrabold mb-6 leading-tight"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          {typedHeadline}
          <span className="blinking-cursor">|</span>
        </motion.h1>

        <motion.p
          className="text-white text-base sm:text-lg md:text-xl 
                     mb-8 sm:mb-10 max-w-[90%] sm:max-w-2xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          {paragraph}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.7 }}
        >
          <Link
            to="/about"
            className="px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg 
                       bg-orange-500 hover:bg-orange-600 text-white font-semibold  rounded-xl transition duration-300"
          >
            Learn More
          </Link>
        </motion.div>
      </div>

      {/* Cursor blink animation */}
      <style>
        {`
          .blinking-cursor {
            animation: blink 1s steps(2, start) infinite;
          }
          @keyframes blink {
            to { opacity: 0; }
          }
        `}
      </style>
    </section>
  );
}

export default Hero;
